import React from "react";
import { HomeStyle } from "./style";
import logo from './image/logo.jpeg'
import DefaultButton from "../shared/DefaultButton";

export default function Home() {
    return(
        <HomeStyle id="home">
            <div>
                <img src={logo} alt="Logo-marca"/>
                <div>
                    <h3>Valentin Negri</h3>
                    <p>O melhor lugar para cuidar das suas roupas, aqui elas ganham um verdadeiro trato vip!</p>
                    <a href="#location">
                        <DefaultButton style={{backgroundColor: '#019acb', textDecoration: 'none', color: 'white'}} href={'#contact'} text={'Veja a localização'}/>
                    </a>
                </div>
            </div>
        </HomeStyle> 
    )
}

// background-color: #019acb;
// color: #ffffff;
// 